module.exports = __webpack_public_path__ + "img/analysis.c81dc486.svg";